// Define the Splide configuration object
const splideConfig = {
    perPage: 3,
    focus  : 0,
    omitEnd: true,
    perMove: 1,
    padding: { right: '0%' },
    pagination: false, // Set these to false initially
    arrows: false,     // We'll control them via overflow
    drag: false,
    breakpoints : {
      989: {
        perPage: 2,
        perMove: 1,
        gap: '0px',
        arrows: true,
        pagination: true,
        padding: { right: '20%' },
      },
      767: {
        perPage: 1,
        perMove: 1,
        gap: '0px',
        arrows: true,
        pagination: true,
        padding: { right: '20%' },
      },
      430: {
        perPage: 1,
        perMove: 1,
        gap: '0px',
        arrows: true,
        pagination: true,
        padding: { right: '10%' },
      },
    },     
  };
  
  // Function to determine the correct padding based on viewport width.
  // This mirrors your breakpoint settings.
  function getCurrentPadding() {
    const width = window.innerWidth;
    if (width <= 430) {
      return { right: '10%' };
    } else if (width <= 767) {
      return { right: '20%' };
    } else if (width <= 989) {
      return { right: '20%' };
    } else {
      return { right: '0%' };
    }
  }
  
  // Function to initialize Splide
  function initSplide() {
    const splide = new Splide('#multicolumn-about', splideConfig);
  
    // Add overflow event handler for pagination, arrows, and drag
    splide.on('overflow', function(isOverflow) {
      const options = {
        arrows: isOverflow,
        pagination: isOverflow,
        drag: isOverflow,
      };
  
      // Update the slider options with the new overflow values
      splide.options = { ...splide.options, ...options };
  
      // Refresh the slider to apply changes
      if (splide.initialized) {
        splide.refresh();
      }
    });
  
    // Listen for window resize events to update the padding.
    // You could also use splide's own "resize" event.
    window.addEventListener('resize', () => {
      // Get the updated padding value based on current window width.
      const newPadding = getCurrentPadding();
      // Update the slider options with the new padding.
      splide.options = { ...splide.options, padding: newPadding };
  
      // Refresh the slider to apply changes.
      if (splide.initialized) {
        splide.refresh();
      }
    });
  
    splide.mount();
  }
  
  // Add event listeners
  document.addEventListener('DOMContentLoaded', initSplide);
  document.addEventListener('shopify:section:load', initSplide);
  